import { PersonSupplementaryInsuranceState, SupplementaryInsuranceProductState } from '../states/offer/offer.state';

export interface OrderedSupplementaryInsurance {
  key: keyof PersonSupplementaryInsuranceState;
  insuranceState: SupplementaryInsuranceProductState;
}

function isInsuranceSelected(
  insurance: Partial<OrderedSupplementaryInsurance>,
): insurance is OrderedSupplementaryInsurance {
  return insurance.insuranceState !== undefined;
}

/** This function defines in which order the supplementary products
 * are displayed in places like the basket or the summary page. */
export function getOrderedSupplementaryInsurances(
  insuranceData: PersonSupplementaryInsuranceState,
): OrderedSupplementaryInsurance[] {
  const products: Partial<OrderedSupplementaryInsurance>[] = [
    {
      key: 'basic',
      insuranceState: insuranceData.basic,
    },
    {
      key: 'outpatient',
      insuranceState: insuranceData.outpatient,
    },
    {
      key: 'outpatientComfort',
      insuranceState: insuranceData.outpatientComfort,
    },
    {
      key: 'complementary',
      insuranceState: insuranceData.complementary,
    },
    {
      key: 'hospital',
      insuranceState: insuranceData.hospital,
    },
    {
      key: 'outpatientViva',
      insuranceState: insuranceData.outpatientViva,
    },
    {
      key: 'complementaryViva',
      insuranceState: insuranceData.complementaryViva,
    },
    {
      key: 'hospitalViva',
      insuranceState: insuranceData.hospitalViva,
    },
    {
      key: 'hospitalCapital',
      insuranceState: insuranceData.hospitalCapital,
    },
    {
      key: 'dental',
      insuranceState: insuranceData.dental,
    },
    {
      key: 'accidentDeathCapital',
      insuranceState: insuranceData.accidentDeathCapital,
    },
    {
      key: 'accidentDisabilityCapital',
      insuranceState: insuranceData.accidentDisabilityCapital,
    },
    {
      key: 'sicknessDeathOrDisabilityCapital',
      insuranceState: insuranceData.sicknessDeathOrDisabilityCapital,
    },
    {
      key: 'legalProtection',
      insuranceState: insuranceData.legalProtection,
    },
    {
      key: 'dailyCash',
      insuranceState: insuranceData.dailyCash,
    },
    {
      key: 'hospitalDailyCash',
      insuranceState: insuranceData.hospitalDailyCash,
    },
    {
      key: 'emergencyCare',
      insuranceState: insuranceData.emergencyCare,
    },
    {
      key: 'accidentMedicalExpensesSupplement',
      insuranceState: insuranceData.accidentMedicalExpensesSupplement,
    },
  ];
  return products.filter(isInsuranceSelected);
}
